import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { CustomValidators } from 'src/validators';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  form: FormGroup;
  submiting: boolean = false;

  constructor(
    fb: FormBuilder,
    private route: ActivatedRoute,
    private http: HttpService,
    private router: Router,
    private snackbar: MatSnackBar,
    private errorReport: ErrorReportService
  ) {

    this.form = fb.group({
      email: [null, Validators.required],
      token: [null, Validators.required],
      password: [null, Validators.required],
      password2: [null, [Validators.required, CustomValidators.match('password')]]
    });

  }

  ngOnInit(): void {

    this.route.params.subscribe(
      params => {
        this.form.patchValue({ token: params.token });
      }
    )

    this.route.queryParams.subscribe(
      params => {
        this.form.patchValue({ email: params.email });
      }
    )

    const subject = new Subject();
    subject.subscribe(
      (result: any) => {
        const { trigger, scope } = result;

        if (scope === 'auth:login')
          this.submiting = (trigger === 'pre')

      }
    )
    this.http.setLoadingIndicator(subject);

  }

  submit() {

    const data = this.form.getRawValue();
    const isValid = !this.form.invalid;

    if (isValid) {

      this.http.save('auth:reset', data)
        .subscribe(
          (result: any) => {
            // console.log('RETORNO SENHA',result);
            if (result.type === 'OK') {
              //if(result > 0) {
              this.snackbar.open('Sua senha foi alterar com sucesso!', 'OK', { duration: 3000 });
              this.router.navigate(['/']);
              // }
              // else{ 
              //   this.snackbar.open('Esse link esta invalido, verifique se esta o usando um link atualizado enviado para seu email', 'OK', { duration: 6000 });
              // }
            } else {
              this.snackbar.open('Não foi possivel alterar sua senha!', 'OK', { duration: 3000 });
            }
          },
          err => this.errorReport.showMessage(err)
        )

    }


  }

}
